"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPoetryDependencies = getPoetryDependencies;
const tslib_1 = require("tslib");
const fs = require("fs");
const path = require("path");
const poetry = require("snyk-poetry-lockfile-parser");
const inspect_implementation_1 = require("./inspect-implementation");
const types_1 = require("../types");
function getPoetryDependencies(command_1, root_1, targetFile_1) {
    return tslib_1.__awaiter(this, arguments, void 0, function* (command, root, targetFile, includeDevDeps = false, includeComponentMetadata = false) {
        const lockfilePath = path.isAbsolute(targetFile)
            ? targetFile
            : path.join(root, targetFile);
        const baseDir = path.dirname(lockfilePath);
        const manifestPath = path.join(baseDir, types_1.FILENAMES.poetry.manifest);
        const manifestExists = fs.existsSync(manifestPath);
        if (!manifestExists) {
            throw new Error('Cannot find manifest file ' + manifestPath);
        }
        const lockfileExists = fs.existsSync(lockfilePath);
        if (!lockfileExists) {
            throw new Error('Cannot find lockfile ' + lockfilePath);
        }
        try {
            const manifestContents = fs.readFileSync(manifestPath, 'utf-8');
            const lockfileContents = fs.readFileSync(lockfilePath, 'utf-8');
            const dependencyGraph = poetry.buildDepGraph(manifestContents, lockfileContents, includeDevDeps, includeComponentMetadata);
            const plugin = yield (0, inspect_implementation_1.getMetaData)(command, [], root, targetFile);
            return {
                plugin,
                package: null,
                dependencyGraph,
            };
        }
        catch (error) {
            let errorMessage;
            if (error instanceof Error) {
                errorMessage = error.message;
            }
            else if (error &&
                typeof error === 'object' &&
                ('stderr' in error || 'stdout' in error)) {
                errorMessage = `stderr: ${error.stderr}\nstdout: ${error.stdout}`;
                if (errorMessage.includes('ENOENT') && errorMessage.includes(command)) {
                    errorMessage = `Could not find '${command}' on your PATH.\n${errorMessage}`;
                }
            }
            else {
                errorMessage = JSON.stringify(error);
            }
            throw new Error('Error processing poetry project. ' + errorMessage);
        }
    });
}
//# sourceMappingURL=poetry.js.map